import { useCallback } from 'react';
import { type Alias } from '#shared/api/schema';
import { alertSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';
import { constructorTestIds } from '#shared/lib/testids';
import { showSuccess } from '#shared/lib/toast';
import { CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS, CONSTRUCTOR_PRODUCT_CARD_ALIAS } from '../model/constants';
import { deleteConstructorPage, getConstructorPageSettings } from '../model/slices';

const getBodyTextByAlias = (alias: Alias) => {
    switch (alias) {
        case CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS:
            return 'Все прикрепленные к этому шаблону категории и коллекции автоматически прикрепятся к Шаблону по умолчанию.';

        case CONSTRUCTOR_PRODUCT_CARD_ALIAS:
            return 'Все прикрепленные к этому шаблону товары автоматически прикрепятся к Шаблону по умолчанию.';

        default:
            return '';
    }
};

export const useConstructorDeletePage = () => {
    const { confirm, renderConfirmModal } = useConfirm();
    const deletePage = useCallback(
        async (pageId: string) => {
            const page = getConstructorPageSettings(pageId);

            if (!page) {
                return;
            }

            const isTemplate = page.variant_type === 'alternative';

            const isConfirmed = await confirm({
                imageSrc: alertSrc,
                title: `Уверены, что хотите удалить ${isTemplate ? 'шаблон' : 'страницу'}?`,
                bodyText: isTemplate ? getBodyTextByAlias(page.alias) : undefined,
                applyText: 'Да, удалить',
                'data-testid': constructorTestIds.deleteConfirmModal,
                applyButtonTestId: constructorTestIds.deleteConfirm,
            });

            if (!isConfirmed) {
                return;
            }

            deleteConstructorPage(pageId);
            showSuccess('Страница удалена');
        },
        [confirm]
    );

    return { deletePage, renderConfirmModal };
};
